import { MapSubtype, MapSubtypeId, MapType, MapTypeId, PerfData, ScaleId } from '../types'

export const EXPANDED_MAP_BODY_CLASSS = 'is-map-expanded'
export const FALLBACK_PERF_RESPONSE: PerfData = { nodes: {}, additional: {}, subtype: MapSubtypeId.DayPerf, hash: '' }

type SubtypesRecord = Record<string, MapSubtype>
type SubtypesGroup = { items: MapSubtype[] }

const MAP_SUBTYPES_INTRADAY_BY_ID: SubtypesRecord = {
  [MapSubtypeId.IntradayPerf1m]: {
    value: MapSubtypeId.IntradayPerf1m,
    label: '1-Minute Performance',
    scaleId: ScaleId.IntradayReduced,
    tooltip:
      'Color indicates 1 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf2m]: {
    value: MapSubtypeId.IntradayPerf2m,
    label: '2-Minute Performance',
    scaleId: ScaleId.IntradayReduced,
    tooltip:
      'Color indicates 2 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf3m]: {
    value: MapSubtypeId.IntradayPerf3m,
    label: '3-Minute Performance',
    scaleId: ScaleId.IntradayReduced,
    tooltip:
      'Color indicates 3 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf5m]: {
    value: MapSubtypeId.IntradayPerf5m,
    label: '5-Minute Performance',
    scaleId: ScaleId.IntradayReduced,
    tooltip:
      'Color indicates 5 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf10m]: {
    value: MapSubtypeId.IntradayPerf10m,
    label: '10-Minute Performance',
    scaleId: ScaleId.IntradayReduced,
    tooltip:
      'Color indicates 10 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf15m]: {
    value: MapSubtypeId.IntradayPerf15m,
    label: '15-Minute Performance',
    scaleId: ScaleId.IntradayReduced,
    tooltip:
      'Color indicates 15 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf30m]: {
    value: MapSubtypeId.IntradayPerf30m,
    label: '30-Minute Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      'Color indicates 30 minute stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf1h]: {
    value: MapSubtypeId.IntradayPerf1h,
    label: '1-Hour Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      'Color indicates 1 hour stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf2h]: {
    value: MapSubtypeId.IntradayPerf2h,
    label: '2-Hour Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      'Color indicates 2 hour stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerf4h]: {
    value: MapSubtypeId.IntradayPerf4h,
    label: '4-Hour Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      'Color indicates 4 hour stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.IntradayPerfAH]: {
    value: MapSubtypeId.IntradayPerfAH,
    label: 'After-Hours Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      'Color indicates after-hours stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
}

const MAP_SUBTYPES_INTERDAY_BY_ID: SubtypesRecord = {
  [MapSubtypeId.DayPerf]: {
    value: MapSubtypeId.DayPerf,
    label: '1-Day Performance',
    scaleId: ScaleId.DayPerf,
    tooltip:
      "Color indicates today's stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.WeekPerf]: {
    value: MapSubtypeId.WeekPerf,
    label: '1-Week Performance',
    scaleId: ScaleId.WeekPerf,
    tooltip:
      'Color indicates weekly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.MonthPerf]: {
    value: MapSubtypeId.MonthPerf,
    label: '1-Month Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      'Color indicates monthly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.MonthToDatePerf]: {
    value: MapSubtypeId.MonthToDatePerf,
    label: 'Month to Date Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      'Color indicates month to date stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ThreeMonthPerf]: {
    value: MapSubtypeId.ThreeMonthPerf,
    label: '3-Month Performance',
    scaleId: ScaleId.ThreeMonthPerf,
    tooltip:
      'Color indicates quarterly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SixMonthPerf]: {
    value: MapSubtypeId.SixMonthPerf,
    label: '6-Month Performance',
    scaleId: ScaleId.SixMonthPerf,
    tooltip:
      'Color indicates half-yearly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.YearToDatePerf]: {
    value: MapSubtypeId.YearToDatePerf,
    label: 'Year to Date Performance',
    scaleId: ScaleId.YearPerf,
    tooltip:
      'Color indicates year to date stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.YearPerf]: {
    value: MapSubtypeId.YearPerf,
    label: '1-Year Performance',
    scaleId: ScaleId.YearPerf,
    tooltip:
      'Color indicates yearly stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ThreeYearPerf]: {
    value: MapSubtypeId.ThreeYearPerf,
    label: '3-Year Performance',
    scaleId: ScaleId.ThreeYearPerf,
    tooltip:
      'Color indicates 3-year stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.FiveYearPerf]: {
    value: MapSubtypeId.FiveYearPerf,
    label: '5-Year Performance',
    scaleId: ScaleId.FiveYearPerf,
    tooltip:
      'Color indicates 5-year stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.TenYearPerf]: {
    value: MapSubtypeId.TenYearPerf,
    label: '10-Year Performance',
    scaleId: ScaleId.TenYearPerf,
    tooltip:
      'Color indicates 10-year stock performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
}

export const MAP_SUBTYPES_GENERAL: SubtypesRecord = {
  [MapSubtypeId.RelativeVolume]: {
    value: MapSubtypeId.RelativeVolume,
    label: 'Relative Volume',
    scaleId: ScaleId.RelativeVolume,
    tooltip:
      "Color indicates the stock's relative volume, ratio between today's and average volume. Values above 1.5 show strong volume, values below 0.5 indicate weak volume.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceToEarnings]: {
    value: MapSubtypeId.PriceToEarnings,
    label: 'P/E',
    scaleId: ScaleId.PriceToEarnings,
    tooltip: "Color indicates the stock's price-to-earnings ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ForwardPriceToEearnings]: {
    value: MapSubtypeId.ForwardPriceToEearnings,
    label: 'Forward P/E',
    scaleId: ScaleId.ForwardPriceToEearnings,
    tooltip: "Color indicates the stock's forward price-to-earnings ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceEarningsToGrowth]: {
    value: MapSubtypeId.PriceEarningsToGrowth,
    label: 'PEG',
    scaleId: ScaleId.PriceEarningsToGrowth,
    tooltip: "Color indicates the stock's price-to-earnings-to-growth ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceToSellsRatio]: {
    value: MapSubtypeId.PriceToSellsRatio,
    label: 'P/S',
    scaleId: ScaleId.PriceToSellsRatio,
    tooltip: "Color indicates the stock's price-to-sales ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.PriceToBookRatio]: {
    value: MapSubtypeId.PriceToBookRatio,
    label: 'P/B',
    scaleId: ScaleId.PriceToBookRatio,
    tooltip: "Color indicates the stock's price-to-book ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EVEbitda]: {
    value: MapSubtypeId.EVEbitda,
    label: 'EV/EBITDA',
    scaleId: ScaleId.EVEbitda,
    tooltip: "Color indicates the stock's EV/EBITDA ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EVSales]: {
    value: MapSubtypeId.EVSales,
    label: 'EV/Sales',
    scaleId: ScaleId.EVSales,
    tooltip: "Color indicates the stock's EV/Sales ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.DividendYield]: {
    value: MapSubtypeId.DividendYield,
    label: 'Dividend Yield',
    scaleId: ScaleId.DividendYield,
    tooltip: "Color indicates the stock's dividend yield.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.DividendGrowth1y]: {
    value: MapSubtypeId.DividendGrowth1y,
    label: 'Dividend Growth 1 Year',
    scaleId: ScaleId.DividendGrowth,
    tooltip: "Color indicates the stock's dividend growth over the past year.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.DividendGrowth3y]: {
    value: MapSubtypeId.DividendGrowth3y,
    label: 'Dividend Growth 3 Years',
    scaleId: ScaleId.DividendGrowth,
    tooltip: "Color indicates the stock's annualized dividend growth over the past 3 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.DividendGrowth5y]: {
    value: MapSubtypeId.DividendGrowth5y,
    label: 'Dividend Growth 5 Years',
    scaleId: ScaleId.DividendGrowth,
    tooltip: "Color indicates the stock's annualized dividend growth over the past 5 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSThisYear]: {
    value: MapSubtypeId.EPSThisYear,
    label: 'EPS This Year',
    scaleId: ScaleId.EPSThisYear,
    tooltip: "Color indicates the stock's estimated earnings per share for this year.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSNextYear]: {
    value: MapSubtypeId.EPSNextYear,
    label: 'EPS Next Year',
    scaleId: ScaleId.EPSNextYear,
    tooltip: "Color indicates the stock's estimated earnings per share for next year.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSQuarterOverQuarter]: {
    value: MapSubtypeId.EPSQuarterOverQuarter,
    label: 'EPS Q/Q',
    scaleId: ScaleId.EPSQuarterOverQuarter,
    tooltip: "Color indicates the stock's quarter-over-quarter earnings per share growth.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSTTM]: {
    value: MapSubtypeId.EPSTTM,
    label: 'EPS TTM',
    scaleId: ScaleId.EPSTTM,
    tooltip: "Color indicates the stock's trailing twelve months earnings per share.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSGrowth3y]: {
    value: MapSubtypeId.EPSGrowth3y,
    label: 'EPS Growth Past 3 Years',
    scaleId: ScaleId.EPSGrowth5y,
    tooltip: "Color indicates the stock's annual earnings (EPS) growth over past 3 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSGrowth5y]: {
    value: MapSubtypeId.EPSGrowth5y,
    label: 'EPS Growth Past 5 Years',
    scaleId: ScaleId.EPSGrowth5y,
    tooltip: "Color indicates the stock's annual earnings (EPS) growth over past 5 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSNext5Years]: {
    value: MapSubtypeId.EPSNext5Years,
    label: 'EPS Next 5 Years',
    scaleId: ScaleId.EPSNext5Years,
    tooltip: "Color indicates the stock's estimated earnings per share growth for the next 5 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EPSSurprise]: {
    value: MapSubtypeId.EPSSurprise,
    label: 'EPS Surprise',
    scaleId: ScaleId.EPSSurprise,
    tooltip: 'Color indicates EPS surprise.',
    countIndustryPerf: false,
    countSectorPerf: false,
  },
  [MapSubtypeId.SalesQuarterOverQuarter]: {
    value: MapSubtypeId.SalesQuarterOverQuarter,
    label: 'Sales Q/Q',
    scaleId: ScaleId.SalesQuarterOverQuarter,
    tooltip: "Color indicates the stock's quarter-over-quarter sales growth.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SalesTTM]: {
    value: MapSubtypeId.SalesTTM,
    label: 'Sales TTM',
    scaleId: ScaleId.SalesTTM,
    tooltip: "Color indicates the stock's trailing twelve months sales growth.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SalesGrowth3y]: {
    value: MapSubtypeId.SalesGrowth3y,
    label: 'Sales Growth Past 3 Years',
    scaleId: ScaleId.SalesGrowth,
    tooltip: "Color indicates the stock's annual sales growth over past 3 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SalesGrowth5y]: {
    value: MapSubtypeId.SalesGrowth5y,
    label: 'Sales Growth Past 5 Years',
    scaleId: ScaleId.SalesGrowth,
    tooltip: "Color indicates the stock's annual sales growth over past 5 years.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.SalesSurprise]: {
    value: MapSubtypeId.SalesSurprise,
    label: 'Sales Surprise',
    scaleId: ScaleId.SalesSurprise,
    tooltip: 'Color indicates sales surprise.',
    countIndustryPerf: false,
    countSectorPerf: false,
  },
  [MapSubtypeId.ROA]: {
    value: MapSubtypeId.ROA,
    label: 'ROA',
    scaleId: ScaleId.ROA,
    tooltip: "Color indicates the stock's return on assets.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ROE]: {
    value: MapSubtypeId.ROE,
    label: 'ROE',
    scaleId: ScaleId.ROE,
    tooltip: "Color indicates the stock's return on equity.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.ROIC]: {
    value: MapSubtypeId.ROIC,
    label: 'ROIC',
    scaleId: ScaleId.ROIC,
    tooltip: "Color indicates the stock's return on invested capital.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.QuickRatio]: {
    value: MapSubtypeId.QuickRatio,
    label: 'Quick Ratio',
    scaleId: ScaleId.QuickRatio,
    tooltip: "Color indicates the stock's quick ratio (Acid-Test Ratio).",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.CurrentRatio]: {
    value: MapSubtypeId.CurrentRatio,
    label: 'Current Ratio',
    scaleId: ScaleId.CurrentRatio,
    tooltip: "Color indicates the stock's current ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.LTDebtEquity]: {
    value: MapSubtypeId.LTDebtEquity,
    label: 'LT Debt/Equity',
    scaleId: ScaleId.LTDebtEquity,
    tooltip: "Color indicates the stock's long-term debt to equity ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.DebtEquity]: {
    value: MapSubtypeId.DebtEquity,
    label: 'Debt/Equity',
    scaleId: ScaleId.DebtEquity,
    tooltip: "Color indicates the stock's total debt to equity ratio.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.GrossMargin]: {
    value: MapSubtypeId.GrossMargin,
    label: 'Gross Margin',
    scaleId: ScaleId.GrossMargin,
    tooltip: "Color indicates the stock's gross profit margin.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.OperatingMargin]: {
    value: MapSubtypeId.OperatingMargin,
    label: 'Operating Margin',
    scaleId: ScaleId.OperatingMargin,
    tooltip: "Color indicates the stock's operating profit margin.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.NetMargin]: {
    value: MapSubtypeId.NetMargin,
    label: 'Net Margin',
    scaleId: ScaleId.NetMargin,
    tooltip: "Color indicates the stock's net profit margin.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.InsiderTransactions]: {
    value: MapSubtypeId.InsiderTransactions,
    label: 'Insider Transactions',
    scaleId: ScaleId.InsiderTransactions,
    tooltip: 'Color indicates Insider transactions (6-Month change in Insider Ownership)',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.FloatShort]: {
    value: MapSubtypeId.FloatShort,
    label: 'Float Short',
    scaleId: ScaleId.FloatShort,
    tooltip: "Color indicates percent of the stock's float sold short.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.AnalystRecommendation]: {
    value: MapSubtypeId.AnalystRecommendation,
    label: 'Analysts Recom.',
    scaleId: ScaleId.AnalystRecommendation,
    tooltip:
      "Color indicates the analyst's recommendations for given stocks. The rating is based on a 1-5 scale, ranging from a strong-buy, to a strong-sell.",
    countIndustryPerf: true,
    countSectorPerf: true,
  },
  [MapSubtypeId.EarningsPerf]: {
    value: MapSubtypeId.EarningsPerf,
    label: 'Earnings Day Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      "Color indicates stock's performance on earnings day. Next day performance for earnings reported after market close.",
    countIndustryPerf: false,
    countSectorPerf: false,
  },
  [MapSubtypeId.EarningsDate]: {
    value: MapSubtypeId.EarningsDate,
    label: 'Earnings Date',
    scaleId: ScaleId.EarningsDate,
    tooltip: "Color indicates stock's earnings date.",
    countIndustryPerf: false,
    countSectorPerf: false,
  },
}

export const MAP_SUBTYPE_DAY_PERF = MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.DayPerf]
export const MAP_SUBTYPE_MANAGERS_FUNDS = {
  value: MapSubtypeId.ManagersAndFunds,
  label: 'Holdings',
  scaleId: ScaleId.PercentHundred,
  tooltip:
    'Color indicates holdings change in percent for currently selected quarter. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
  countIndustryPerf: true,
  countSectorPerf: true,
}

const MAP_SUBTYPES_INTRADAY: SubtypesGroup = { items: Object.values(MAP_SUBTYPES_INTRADAY_BY_ID) }
const MAP_SUBTYPES_INTERDAY: SubtypesGroup = { items: Object.values(MAP_SUBTYPES_INTERDAY_BY_ID) }
const MAP_SUBTYPES_TIMEFRAMES: SubtypesGroup[] = FinvizSettings.hasUserPremium
  ? [MAP_SUBTYPES_INTRADAY, MAP_SUBTYPES_INTERDAY]
  : [
      {
        items: [
          {
            label: 'Intraday',
            // @ts-expect-error - This isn't a real selectable option, it'll redirect users on click
            href: '/elite?utm_source=finviz&utm_medium=banner&utm_campaign=maps_intraday',
            reloadDocument: true,
          },
        ],
      },
      MAP_SUBTYPES_INTERDAY,
    ]

export const MAP_SUBTYPES_COMPANIES: SubtypesGroup[] = [
  ...MAP_SUBTYPES_TIMEFRAMES,
  { items: Object.values(MAP_SUBTYPES_GENERAL) },
]

export const MAP_SUBTYPES_ETF: SubtypesGroup[] = [
  ...MAP_SUBTYPES_TIMEFRAMES,
  {
    items: [
      MAP_SUBTYPES_GENERAL[MapSubtypeId.RelativeVolume],
      {
        value: MapSubtypeId.DividendYield,
        label: 'Dividend Yield',
        scaleId: ScaleId.DividendYield,
        tooltip: "Color indicates the stock's dividend yield.",
        countIndustryPerf: true,
        countSectorPerf: true,
      },
      {
        value: MapSubtypeId.DividendGrowth1y,
        label: 'Dividend Growth 1 Year',
        scaleId: ScaleId.DividendGrowth,
        tooltip: "Color indicates the stock's dividend growth over the past year.",
        countIndustryPerf: true,
        countSectorPerf: true,
      },
      {
        value: MapSubtypeId.DividendGrowth3y,
        label: 'Dividend Growth 3 Years',
        scaleId: ScaleId.DividendGrowth,
        tooltip: "Color indicates the stock's annualized dividend growth over the past 3 years.",
        countIndustryPerf: true,
        countSectorPerf: true,
      },
      {
        value: MapSubtypeId.DividendGrowth5y,
        label: 'Dividend Growth 5 Years',
        scaleId: ScaleId.DividendGrowth,
        tooltip: "Color indicates the stock's annualized dividend growth over the past 5 years.",
        countIndustryPerf: true,
        countSectorPerf: true,
      },
    ],
  },
]

const MAP_CRYPTO_INTRADAY_SUBTYPE_IDS: MapSubtypeId[] = [
  MapSubtypeId.IntradayPerf1m,
  MapSubtypeId.IntradayPerf3m,
  MapSubtypeId.IntradayPerf5m,
  MapSubtypeId.IntradayPerf15m,
  MapSubtypeId.IntradayPerf30m,
  MapSubtypeId.IntradayPerf1h,
]

const MAP_CRYPTO_INTERDAY_SUBTYPE_IDS: MapSubtypeId[] = [
  MapSubtypeId.DayPerf,
  MapSubtypeId.WeekPerf,
  MapSubtypeId.MonthPerf,
  MapSubtypeId.MonthToDatePerf,
  MapSubtypeId.ThreeMonthPerf,
  MapSubtypeId.SixMonthPerf,
  MapSubtypeId.YearPerf,
  MapSubtypeId.YearToDatePerf,
]

const MAP_SUBTYPES_CRYPTO_INTERDAY_BY_ID: SubtypesRecord = {
  [MapSubtypeId.MonthToDatePerf]: {
    value: MapSubtypeId.MonthToDatePerf,
    label: 'Month to Date Performance',
    scaleId: ScaleId.MonthPerf,
    tooltip:
      'Color indicates month to date crypto performance in percent. Based on the color you can identify losers (red), neutral (black), and gainers (green).',
    countIndustryPerf: true,
    countSectorPerf: true,
  },
}

export const MAP_SUBTYPES_CRYPTO: SubtypesGroup[] = [
  {
    items: MAP_CRYPTO_INTRADAY_SUBTYPE_IDS.map((id) => ({
      ...MAP_SUBTYPES_INTRADAY_BY_ID[id],
      tooltip: MAP_SUBTYPES_INTRADAY_BY_ID[id].tooltip.replace('stock', 'crypto'),
    })),
  },
  {
    items: MAP_CRYPTO_INTERDAY_SUBTYPE_IDS.map(
      (id) =>
        MAP_SUBTYPES_CRYPTO_INTERDAY_BY_ID[id] ?? {
          ...MAP_SUBTYPES_INTERDAY_BY_ID[id],
          tooltip: MAP_SUBTYPES_INTERDAY_BY_ID[id].tooltip.replace('stock', 'crypto'),
        }
    ),
  },
]

export const MAP_SUBTYPES_FUTURES = [
  MAP_SUBTYPES_INTRADAY_BY_ID[MapSubtypeId.IntradayPerf5m],
  MAP_SUBTYPES_INTRADAY_BY_ID[MapSubtypeId.IntradayPerf1h],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.DayPerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.WeekPerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.MonthPerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.MonthToDatePerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.ThreeMonthPerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.SixMonthPerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.YearPerf],
  MAP_SUBTYPES_INTERDAY_BY_ID[MapSubtypeId.YearToDatePerf],
].map((subtype) => ({
  ...subtype,
  tooltip: subtype.tooltip.replace('stock', 'futures'),
}))

export const MAP_TYPE_FUTURES = {
  name: 'Futures',
  pageTitle: 'Futures Map',
  nameShort: 'Futures',
  description: 'Size represents the notional open interest of each futures contract.',
  type: MapTypeId.Futures,
  subtypes: [{ items: MAP_SUBTYPES_FUTURES }],
}

export const MAP_TYPES: MapType[] = [
  {
    name: 'S&P 500',
    pageTitle: 'S&P 500 Map',
    description:
      "Standard and Poor's 500 index stocks categorized by sectors and industries. Size represents market cap.",
    type: MapTypeId.Sector,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'Dow Jones 30',
    pageTitle: 'Dow Jones 30 Map',
    description:
      'Dow Jones Industrial Average stocks categorized by sectors and industries. Size represents market cap.',
    type: MapTypeId.Dow,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'Nasdaq 100',
    pageTitle: 'Nasdaq 100 Map',
    description: 'NASDAQ-100 index stocks categorized by sectors and industries. Size represents market cap.',
    type: MapTypeId.Nasdaq,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'Russell 2000',
    pageTitle: 'Russell 2000 Map',
    description: 'Russell 2000 index stocks categorized by sectors and industries. Size represents market cap.',
    type: MapTypeId.Russell,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'All Stocks',
    pageTitle: 'Stock Market Map',
    description:
      'All stocks listed on US stock exchanges, categorized by sectors and industries. Size represents market cap.',
    type: MapTypeId.SectorFull,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'World',
    pageTitle: 'World Map',
    description:
      'Foreign ADR stocks listed on NYSE, NASDAQ, AMEX categorized by geo location. Size represents market cap.',
    type: MapTypeId.World,
    subtypes: MAP_SUBTYPES_COMPANIES,
  },
  {
    name: 'ETFs',
    pageTitle: 'ETF Map - Exchange Traded Funds Map',
    nameShort: 'ETF',
    description: 'ETFs categorized by sectors and styles. Size represents 3-month average dollar volume, $1M minimum.',
    type: MapTypeId.ETF,
    subtypes: MAP_SUBTYPES_ETF,
  },
  {
    name: 'Crypto',
    pageTitle: 'Crypto Map',
    nameShort: 'Crypto',
    description: 'Size reflects each cryptocurrency’s market cap, calculated as current price * circulating supply.',
    type: MapTypeId.CryptoUSD,
    subtypes: MAP_SUBTYPES_CRYPTO,
  },
  {
    name: 'Crypto USDT',
    pageTitle: 'Crypto USDT Map',
    nameShort: 'Crypto',
    description: 'Size reflects each cryptocurrency’s market cap, calculated as current price * circulating supply.',
    type: MapTypeId.CryptoUSDT,
    subtypes: MAP_SUBTYPES_CRYPTO,
    isHidden: true,
  },
  {
    name: 'Crypto EUR',
    pageTitle: 'Crypto EUR Map',
    nameShort: 'Crypto',
    description: 'Size reflects each cryptocurrency’s market cap, calculated as current price * circulating supply.',
    type: MapTypeId.CryptoEUR,
    subtypes: MAP_SUBTYPES_CRYPTO,
    isHidden: true,
  },
  {
    name: 'Crypto BTC',
    pageTitle: 'Crypto BTC Map',
    nameShort: 'Crypto',
    description: 'Size reflects each cryptocurrency’s market cap, calculated as current price * circulating supply.',
    type: MapTypeId.CryptoBTC,
    subtypes: MAP_SUBTYPES_CRYPTO,
    isHidden: true,
  },
  MAP_TYPE_FUTURES,
]

export const MAP_TYPE_SCREENER = {
  name: 'Screener',
  pageTitle: 'Screener Map',
  description:
    'All stocks listed on US stock exchanges, categorized by sectors and industries. Stock size represents market cap.',
  type: MapTypeId.Screener,
  subtypes: MAP_SUBTYPES_COMPANIES,
}

export const MAP_TYPE_ETF_HOLDINGS_WIDGET = {
  name: 'ETF Holdings',
  pageTitle: '',
  description: '',
  type: MapTypeId.ETFHoldings,
  subtypes: MAP_SUBTYPES_COMPANIES,
}

export const MAP_TYPE_MANAGERS_FUNDS_WIDGET = {
  name: 'Holdings',
  pageTitle: '',
  description: '',
  type: MapTypeId.ManagersAndFunds,
  subtypes: [{ items: [MAP_SUBTYPE_MANAGERS_FUNDS] }],
}
